import { render, staticRenderFns } from "./help-popup-component.vue?vue&type=template&id=74b63d44&scoped=true&"
import script from "./help-popup-component.vue?vue&type=script&lang=ts&"
export * from "./help-popup-component.vue?vue&type=script&lang=ts&"
import style0 from "./help-popup-component.vue?vue&type=style&index=0&id=74b63d44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b63d44",
  null
  
)

export default component.exports